<template>
  <div class="radio-form-item__top-content">
    <div>
      <h4>Selbst-Zulassung</h4>
      <p class="radio-form-item__price">€ {{ price }} ,- <span v-if="price !== 0" class="mwst block">inkl. Mwst.</span></p>
    </div>
    <ul class="check-list">
      <li class="no-icon">Ich lasse das Fahrzeug selber zu.</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['order'],
  computed: {
    privateBuyer() {
      return (this.order.private_buyer ? 'private' : 'comercial') || '';
    },
    commercialBuyer() {
      return this.privateBuyer == 'comercial';
    },
    price() {
      if (this.commercialBuyer) {
        return  this.order.car_info.online_offer_services.all_services_b2b.registration.self;
      }
      return  this.order.car_info.online_offer_services.all_services.registration.self;
    },
  },
};
</script>
